import React from 'react';
import { useSelector } from 'react-redux';
import cn from 'classnames';
import styles from '../styles/frame/frame.module.scss';
import Main from './main';
import StakeSettings from './stake/stake-settings';
import StakeDetails from './stake/stake-details';
import StakeConfirm from './stake/stake-confirm';
import StakeSuccess from './stake/stake-success';
import UnstakeSettings from './unstake/unstake-settings';
import UnstakeInformation from './unstake/unstake-information';
import UnstakeDetails from './unstake/unstake-details';
import UnstakeConfirm from './unstake/unstake-confirm';
import UnstakeSuccess from './unstake/unstake-success';
import WithdrawDetails from './withdraw/withdraw-details';
import WithdrawConfirm from './withdraw/withdraw-confirm';
import WithdrawSuccess from './withdraw/withdraw-success';
import MigrateFirstStepDetails from './migrate/migrate-first-step-details';
import MigrateConfirm from './migrate/migrate-confirm';
import MigrateSuccess from './migrate/migrate-success';
import MigrateTimer from './migrate/migrate-timer';
import MigrateSecondStepDetails from './migrate/migrate-second-step-details';
import MigrateFinish from './migrate/migrate-finish';
import Error from './error';
import { useGetTheme } from '../../../../../hooks/useGetTheme';
import { OM_STAKING_MIGRATE_STATUS } from '../../../../../constants/blockchain-constants';

const OmV1Frame = () => {
  const dark = useSelector((state) => state.basic.dark);
  const colors = useGetTheme();

  const { status, migrateStatus, unstakedTime } = useSelector((state) => state.OMstake.stake);

  const timer = unstakedTime * 1000 - new Date().getTime();

  return (
    <div
      className={cn(styles.cardContainer, { [styles.dark]: dark })}
      style={{ color: colors.text, backgroundColor: colors.stakingFrameBackground }}
    >
      {status === 0 && migrateStatus === OM_STAKING_MIGRATE_STATUS.NEED_RUN_MIGRATE ? (
        <Main />
      ) : null}
      {status === 0 &&
      migrateStatus === OM_STAKING_MIGRATE_STATUS.MIGRATED_FIRST_STEP &&
      timer > 0 ? (
        <MigrateTimer />
      ) : null}
      {status === 0 &&
      migrateStatus === OM_STAKING_MIGRATE_STATUS.MIGRATED_FIRST_STEP &&
      timer <= 0 ? (
        <MigrateSecondStepDetails />
      ) : null}
      {status === 0 && migrateStatus === OM_STAKING_MIGRATE_STATUS.MIGRATE_FINISHED ? (
        <MigrateFinish />
      ) : null}

      {/* TODO: stake was deprecated */}
      {status === 1 ? <StakeSettings /> : null}
      {status === 2 ? <StakeDetails /> : null}
      {status === 3 ? <StakeConfirm /> : null}
      {status === 4 ? <StakeSuccess /> : null}

      {status === 20 ? <UnstakeSettings /> : null}
      {status === 21 ? <UnstakeInformation /> : null}
      {status === 22 ? <UnstakeDetails /> : null}
      {status === 23 ? <UnstakeConfirm /> : null}
      {status === 24 ? <UnstakeSuccess /> : null}

      {/* TODO: withdraw was deprecated */}
      {status === 40 ? <WithdrawDetails /> : null}
      {status === 41 ? <WithdrawConfirm /> : null}
      {status === 42 ? <WithdrawSuccess /> : null}

      {status === 50 ? <MigrateFirstStepDetails /> : null}
      {status === 51 ? <MigrateConfirm /> : null}
      {status === 52 ? <MigrateSuccess /> : null}

      {status === 99 ? <Error /> : null}

      {/* {status === 100 ? <History /> : null} */}
    </div>
  );
};

export default OmV1Frame;
